import { Order } from '../../../back-office/Models/Order';

/**
 * US-595: which dealer contact an order is delivered to. Mirrors the API's
 * DeliveryAddressResolver::applyCollectionLocation() (constitution principle 6): a line whose collection has
 * separateDeliveryAddress picks the default contact when primaryDeliveryAddress is set, else the other one.
 * Without such a line the dealer's default contact is used only when the user chose "Delivery at: Dealer"
 * (develop behaviour); otherwise null, so the exports fall back to the primary contact (US-709, research R5, FR-006).
 * Sub-users: the web never sees the parent dealer's contacts (the API serializes `parent` only in the employee-overview
 * group), so the API applies deliverySettingsHolder() on save and this resolver only uses order.user's own contacts.
 */
export function resolveDealerDeliveryAddress(order: Order, deliveryAtDealer: boolean): Order['dealerDeliveryAddress'] {
  const user = order.user;
  const isDefaultSecondary = user.defaultDelivery === Order.DEFAULT_DELIVERY_SECONDARY;
  const secondaryOrPrimary = user.secondaryDeliveryContact ?? user.deliveryContact;
  const defaultDelivery = isDefaultSecondary ? secondaryOrPrimary : user.deliveryContact;
  const separateLine = order.orderItems.find(item => item.collectionObj?.separateDeliveryAddress);
  if (separateLine) {
    const nonDefaultDelivery = isDefaultSecondary ? user.deliveryContact : secondaryOrPrimary;
    return separateLine.collectionObj.primaryDeliveryAddress ? defaultDelivery : nonDefaultDelivery;
  }
  return deliveryAtDealer ? defaultDelivery : null;
}
